import { render } from "./CatDepartamentoForm.vue?vue&type=template&id=16a581ac&scoped=true"
import script from "./CatDepartamentoForm.vue?vue&type=script&lang=js"
export * from "./CatDepartamentoForm.vue?vue&type=script&lang=js"

import "./CatDepartamentoForm.vue?vue&type=style&index=0&id=16a581ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a581ac"]])

export default __exports__